"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icons = _interopRequireDefault(require("../Icons"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Tag = _ref => {
  let {
    children,
    type = 'green',
    className,
    onClick = () => {},
    icon
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-tag ".concat(type, " ").concat(className),
    onClick: onClick
  }, !!icon && /*#__PURE__*/_react.default.createElement(_Icons.default, {
    name: icon
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-tag-text"
  }, children));
};
var _default = exports.default = Tag;